import { useFormContext } from 'react-hook-form'

import { Box } from '@factorialco/deprecated-design-system'
import { CurrencySelectorCurrencyFragment } from 'generated/resources/graphql'

import { CustomizationProps } from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import { PermissionsProps } from 'modules/expenses/components/expenses/Detail/_newForm/withFieldPermissions'
import InlineFields from 'modules/expenses/components/expenses/Form/InlineFields'

import AmountField from './AmountField'
import CurrencyField from './CurrencyField'
import DocumentTypeField from './DocumentTypeField'
import EffectiveOnField from './EffectiveOnField'

interface Props extends PermissionsProps, CustomizationProps {
  currencies?: CurrencySelectorCurrencyFragment[]
  onDocumentTypeChange: (value: string) => void
  onEffectiveOnChange: (value: string) => void
  isAutomaticExpensable: boolean
}

const BasicInformation = (props: Props) => {
  const { watch } = useFormContext()

  const currency = watch('currency')

  return (
    <Box gap="s24">
      <DocumentTypeField
        {...props}
        fieldIdentifier="document_type"
        onDocumentTypeChange={props.onDocumentTypeChange}
      />
      <EffectiveOnField
        {...props}
        fieldIdentifier="effective_on"
        onEffectiveOnChange={props.onEffectiveOnChange}
        isAutomaticExpensable={props.isAutomaticExpensable}
      />
      <InlineFields>
        <CurrencyField
          {...props}
          fieldIdentifier="currency"
          isAutomaticExpensable={props.isAutomaticExpensable}
          currencies={props.currencies}
        />
        <AmountField
          {...props}
          fieldIdentifier="amount"
          isAutomaticExpensable={props.isAutomaticExpensable}
          currency={currency}
        />
      </InlineFields>
    </Box>
  )
}

export default BasicInformation
